<template>
  <div :class="{ 'pe-n': props.name !== 'X' }" @click="onClick">
    <lucide-icon
      :class="classes"
      :name="name"
      :size="20"
      :stroke-width="2"
      color="gray"
    />
  </div>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    name: {
      type: String,
      default: 'ChevronDown',
    },
  });
  const emit = defineEmits(['clearSelection']);

  // If the icon is "LoaderCircle", it means we're loading data and it should spin to indicate this
  const classes = computed(() => ({ 'lh-1': true, 'anim-spin': props.name === 'LoaderCircle' }));

  const onClick = (e) => {
    if (props.name === 'X') emit('clearSelection', e);
  };
</script>
